import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import Tooltip from 'components/Tooltip'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const FAVORITED_ICON_PATH = '/img/bookmark-solid.svg'
const NON_FAVORITED_ICON_PATH = '/img/bookmark-outline.svg'

const propTypes = {
  deviceId: PropTypes.string.isRequired,
  size: PropTypes.string,
  className: PropTypes.string
}

const defaultProps = {
  size: '20',
  className: null
}

const FavoriteIcon = ({ deviceId, size, className }) => {
  const { session: { userId } } = useSessionContext()
  const { favorites } = useStoreContext()

  const [isFavorited, setIsFavorited] = useState(favorites && favorites.includes(deviceId))

  return (isFavorited
    ? (
      <Tooltip title="Remove this device from the favorites list" placement="top-start">
        <KeyboardAccessible
          className={className}
          onClick={() => { Api.Favorite.delete(userId, deviceId).then(() => setIsFavorited(false)) }}
        >
          <S.Icon
            src={FAVORITED_ICON_PATH}
            alt="solid bookmark icon"
            size={size}
          />
        </KeyboardAccessible>
      </Tooltip>
    )
    : (
      <Tooltip title="Add this device to the favorites List" placement="top-start">
        <KeyboardAccessible
          className={className}
          onClick={() => { Api.Favorite.create(userId, deviceId).then(() => setIsFavorited(true)) }}
        >
          <S.Icon
            src={NON_FAVORITED_ICON_PATH}
            alt="outlined bookmark icon"
            size={size}
          />
        </KeyboardAccessible>
      </Tooltip>
    )
  )
}

FavoriteIcon.propTypes = propTypes
FavoriteIcon.defaultProps = defaultProps

export default FavoriteIcon

const S = {
  Icon: styled.img`
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
    cursor: pointer;

    &:hover {
      background-size: ${({ size }) => `${size}px ${size}px`};
      background-image: url(${FAVORITED_ICON_PATH});
    }
  `
}
